import React from "react";
import "./footer.css"

const Footer = ()=>{
    return(
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">Aahwan</h1>
                <span className="footer__copy">Thank you for visiting my portfolio.</span>
            </div>
        </footer>
    )
}

export default Footer;